import { createActionGroup } from '@ngrx/store';

export const CampagneUserActions = createActionGroup({
  source: 'Campagne User',
  events: {}
});
